import useSite from "./useSite";

export default function useLocationUrl(id: string | number | undefined) {
  const site = useSite();
  return `/${site}/locations/${id}`;
}
